import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { AppShell } from '../components/AppShell';
import { LoginPage } from '../components/LoginPage';
import { AuthProvider, useAuth } from '../lib/auth-context';
import { TenantProvider } from '../lib/tenant-context';
import { PermissionsProvider } from '../lib/permissions-context';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </AuthProvider>
  );
}

function AuthenticatedApp() {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FAFAFA' }}>
        <div
          className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin"
          style={{ borderColor: '#00FBA9', borderTopColor: 'transparent' }}
        />
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Authenticated - show app with tenant and permissions context
  return (
    <TenantProvider>
      <PermissionsProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </PermissionsProvider>
    </TenantProvider>
  );
}
